import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Login from './Login';

const UnauthenticatedApp = props => {
  const routes = (
    <Switch>
      <Route path='/login' component={Login} />
      <Route path='/forgot-password' exact component={() => <h1>Login Component</h1>} />
      <Redirect to='/login' />
    </Switch>
  );
  return <Router>{routes}</Router>;
};
export default UnauthenticatedApp;
